import React, {Component} from "react";
import {SubsidiaryUtils} from "../../../../../../utils/Subsidiary/SubsidiaryUtils";
import {ActionCreator} from "../../../../../../actions/actions";
import {AuthActionCreators} from "../../../../actions/actionCreators";
import {connect} from "react-redux";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import UserAvatar from "../../../../../home/components/Topbar/LoggedInUser/UserAvatar/UserAvatar.component";
import {checkAuthorization, isSuperUser} from "../../../../../../utils/Authorization/authorization";
import {AuthAPIRoutes} from "../../../../api/auth.apiRoutes";
import "./UserRow.component.scss";
import {User} from "../../../../reducers/users.reducer";
import {authStoreSelectors} from "../../../../store/store";


export interface UserRowProps {
    changeUserStatus: ActionCreator;
    user: User;
    filters: object;
    open_pop_up: any;
    subsidiaries: any;
}

export interface UserRowState {
    user_status: string;
}

class UserRow extends Component<UserRowProps, UserRowState> {

    constructor(props) {
        super(props);
        this.state = {
            user_status: 'Inactive'
        };
        this.handleRowClick = this.handleRowClick.bind(this);
    }

    componentDidMount() {
        this.setState({user_status: this.props.user.is_active ? 'Active' : 'Inactive'});
    }

    handleOnChange(user_id) {
        this.props.changeUserStatus({user_id: user_id, search_json: this.props.filters});
    }

    componentDidUpdate(prevProps): void {
        if (!prevProps || prevProps.user.is_active !== this.props.user.is_active) {
            this.setState({user_status: this.props.user.is_active ? 'Active' : 'Inactive'})
        }
    }

    handleRowClick(e) {
        if (checkAuthorization({route: AuthAPIRoutes.EDIT_USER})) {
            this.props.open_pop_up(e,
                {
                    drawer_title: "Edit User",
                    user_obj: this.props.user,
                    form_button_name: 'Save',
                    user_action: 'EDIT_USER',
                }
            )
        }
    }

    render() {
        return (
            <tr className="user-row">
                <td className="user-cell" onClick={this.handleRowClick}>
                    <div className="user-cell-header-image">
                        {this.props.user.profile_picture_b64 && this.props.user.profile_picture_b64 !== ''
                            ?
                            <img alt={this.props.user.email}
                                 src={this.props.user.profile_picture_b64.includes('data:image/png;base64')
                                     ? `${this.props.user.profile_picture_b64}`
                                     : `data:image;base64,${this.props.user.profile_picture_b64}`}/>
                            :
                            <UserAvatar size={40} email={this.props.user.email}/>
                        }
                    </div>
                    <span
                        className="username user-row-info">{this.props.user.first_name} {this.props.user.last_name}</span>
                </td>
                <td className={!this.props.user.is_active ? "user-cell other-user-info inactive" : "user-cell other-user-info "}
                    onClick={this.handleRowClick}>
                    {this.props.user.email}
                </td>
                <td className="user-cell" onClick={this.handleRowClick}>
                    <div className="subsidiaries-block">
                        {this.props.user.subsidiaries && this.props.user.subsidiaries.length > 0 ? (
                            this.props.user.subsidiaries.map(sub => {
                                const subsidiary =
                                    this.props.subsidiaries.find(
                                        subd => subd.id == sub.id
                                    );
                                if (subsidiary) {
                                    return (
                                        <div key={sub.id}>
                                            <div className="sub-icon">
                                                {SubsidiaryUtils.subsidiaryIcon(subsidiary)}
                                            </div>
                                            <div className="messages">
                                                <label className="label">
                                                    {subsidiary.description}
                                                </label>
                                            </div>
                                        </div>
                                    );
                                }
                            })
                        ) : (
                            <div className="no-subs">-</div>
                        )}
                    </div>
                </td>
                <td className="user-cell-roles" onClick={this.handleRowClick}>
                    {isSuperUser && this.props.user.is_superuser && (
                        <div
                            key={'admin'}
                            className='custom-admin-user-badge'
                        >
                            Administrator
                        </div>
                    )}
                    {this.props.user.roles && this.props.user.roles.length > 0 ? (
                        this.props.user.roles.map(role => {
                            return (
                                <div
                                    key={role['name']}
                                    className={
                                        !this.props.user.is_active
                                            ? "custom-inactive-user-badge"
                                            : "custom-active-user-badge"
                                    }
                                >
                                    {role['name']}
                                </div>
                            );
                        })
                    ) : !this.props.user.is_superuser && (
                        <div className="other-user-info">
                            -
                        </div>
                    )}
                </td>
                <td className="user-cell-status">
                    <span className="user-status">{this.state.user_status}</span>
                    {checkAuthorization({
                        route: AuthAPIRoutes.CHANGE_USER_STATUS
                    }) && (
                        <Components.Switch
                            onClick={() => this.handleOnChange(this.props.user.id)}
                            on={this.props.user.is_active}
                            enabled
                        />
                    )}
                </td>
            </tr>
        );
    }
}

const mapStateToProps = state => ({
    subsidiaries: authStoreSelectors.subsidiaries(state)
});

const mapDispatchToProps = () => ({
    changeUserStatus: AuthActionCreators.change_user_status
});
export default connect(mapStateToProps, mapDispatchToProps)(UserRow);